import { observer } from "mobx-react";
import { IAppliedFilterChipComponent } from "../BaseChipComponents/IAppliedFilterChipComponent";
import AppliedFilterChipBase from "../BaseChipComponents/AppliedFilterChipBase";
import React from "react";
import { useChipFiltersStore } from "../BaseChipComponents/chipUtils";

export const EddyEffectChip = observer(function (
    props: IAppliedFilterChipComponent,
) {
    const applicationFiltersStore = useChipFiltersStore(props);

    return (
        <AppliedFilterChipBase
            disabled={props.disabled}
            isApplicable={props.isApplicable}
            onRemove={() =>
                applicationFiltersStore.setEddyEffectStatus(undefined)
            }
        >
            {props.item.title}:{" "}
            {applicationFiltersStore.eddyEffectStatus
                ? "Present"
                : "Not Present"}
        </AppliedFilterChipBase>
    );
});
